import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page4"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
import 空间剧本 from '@/assets/v2/page4/空间剧本.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import tu1 from '@/assets/v2/page4-2/图/1.webp';
import tu2 from '@/assets/v2/page4-2/图/2.webp';
import tu3 from '@/assets/v2/page4-2/图/3.webp';
import 垂钓 from '@/assets/v2/page4-2/文字/垂钓.webp';
import 亲子 from '@/assets/v2/page4-2/文字/亲子.webp';
import 闲适 from '@/assets/v2/page4-2/文字/闲适.webp';
export default {
  __name: 'Page4-2',
  setup(__props) {
    // case 5
    // 引入图片

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(空间剧本),
        alt: "空间剧本",
        class: "空间剧本",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('goHome')),
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(tu1),
        alt: "tu1",
        class: "tu1",
        loading: "lazy"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: _unref(垂钓),
        alt: "垂钓",
        class: "垂钓",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(闲适),
        alt: "闲适",
        class: "闲适",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(tu2),
        alt: "tu2",
        class: "tu2",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(tu3),
        alt: "tu3",
        class: "tu3",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(亲子),
        alt: "亲子",
        class: "亲子",
        loading: "lazy"
      }, null, 8, _hoisted_9)]);
    };
  }
};